export default __webpack_public_path__ + "6a9698bf80b1a8e71db66251d380a4c0.svg";